import CryptoJS from "crypto-js";
import {isValidJSON} from "./utils";

export const numericMapper = (char: any) => {
  try {
    let retValue = "";
    switch (char) {
      case "1":
        retValue = "A";
        break;
      case "2":
        retValue = "b";
        break;
      case "3":
        retValue = "C";
        break;
      case "4":
        retValue = "d";
        break;
      case "5":
        retValue = "E";
        break;
      case "6":
        retValue = "f";
        break;
      case "7":
        retValue = "G";
        break;
      case "8":
        retValue = "h";
        break;
      case "9":
        retValue = "I";
        break;
      case "0":
        retValue = "j";
        break;
    }
    return retValue;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const randomIntFromInterval = (min: number, max: number) => {
  try {
    // min and max included
    const autoGenNo = Math.floor(
      Math.random() * (max - min + 1) + min,
    ).toString();
    const randomKey =
      numericMapper(autoGenNo.substring(0, 1)) +
      autoGenNo.substring(1, 2) +
      numericMapper(autoGenNo.substring(2, 3)) +
      autoGenNo.substring(3, 4) +
      numericMapper(autoGenNo.substring(4, 5)) +
      autoGenNo.substring(0, 1) +
      autoGenNo.substring(2, 3) +
      autoGenNo.substring(4, 5);
    return randomKey;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const encrypt = (plainText: any) => {
  try {
    // var CryptoJS = require("crypto-js");
    const keySize = 8;
    const key1 = randomIntFromInterval(10000, 99999);
    const key2 = randomIntFromInterval(10000, 99999);
    const key = key1 + key2;
    const keyPass = CryptoJS.enc.Utf8.parse(key);
    const iv2 = CryptoJS.enc.Base64.parse("QUJDREVGR0g=");
    const encoded = CryptoJS.enc.Utf8.parse(plainText);
    const ciphertext = CryptoJS.TripleDES.encrypt(encoded, keyPass, {
      mode: CryptoJS.mode.CBC,
      iv: iv2,
    });
    const retValue =
      key.substring(0, keySize) +
      ciphertext.ciphertext.toString(CryptoJS.enc.Base64) +
      key.substring(keySize, keySize * 2);
    return retValue;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const decrypt = (encText: any) => {
  try {
    const keySize = 8;
    //  const enctext = "C7A3d314AjDLeA8PyFk=f6C1f636";
    const key1 = encText.substring(0, keySize);
    const key2 = encText.substring(encText.length - keySize, encText.length);
    const key = key1 + key2;
    const enctextprop = encText.substring(keySize, encText.length - keySize);
    const keyPass = CryptoJS.enc.Utf8.parse(key);
    const iv2 = CryptoJS.enc.Base64.parse("QUJDREVGR0g=");
    const bytes = CryptoJS.TripleDES.decrypt(enctextprop, keyPass, {
      mode: CryptoJS.mode.CBC,
      iv: iv2,
    });
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedText;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const encryptAPI = (plainText: any) => {
  try {
    if (process.env.REACT_APP_ENCRYPTION  === "true") {
      plainText = JSON.stringify(plainText);
      const keySize = 8;
      const key1 = randomIntFromInterval(10000, 99999);
      const key2 = randomIntFromInterval(10000, 99999);
      const key = key1 + key2;
      const keyPass = CryptoJS.enc.Utf8.parse(key);
      const iv = CryptoJS.enc.Base64.parse(String(process.env.REACT_APP_CRYPTO_KEY));
      const encoded = CryptoJS.enc.Utf8.parse(plainText);
      const ciphertext = CryptoJS.AES.encrypt(encoded, keyPass, {
        mode: CryptoJS.mode.CBC,
        iv: iv,
      });
      const retValue =
        key.substring(0, keySize) +
        ciphertext.ciphertext.toString(CryptoJS.enc.Base64) +
        key.substring(keySize, keySize * 2);
      return retValue;
    } else {
      return plainText;
    }
  } catch (error: any) {
    throw new Error(error);
  }
};

export const decryptAPI = (encText: any) => {
  try {
    if (process.env.REACT_APP_ENCRYPTION  === "true") {
      const keySize = 8;
      const key1 = encText.substring(0, keySize);
      const key2 = encText.substring(encText.length - keySize, encText.length);
      const key = key1 + key2;
      const enctextprop = encText.substring(keySize, encText.length - keySize);
      const keyPass = CryptoJS.enc.Utf8.parse(key);
      const iv = CryptoJS.enc.Base64.parse(String(process.env.REACT_APP_CRYPTO_KEY));
      const bytes = CryptoJS.AES.decrypt(enctextprop, keyPass, {
        mode: CryptoJS.mode.CBC,
        iv: iv,
      });
      const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

      if (isValidJSON(decryptedText)) {
        return JSON.parse(decryptedText);
      } else {
        return decryptedText;
      }
    } else {
      return encText;
    }
  } catch (error: any) {
    throw new Error(error);
  }
};